import { Flex } from "@chakra-ui/react";
import { Spin } from "antd";
import usePermissions from "core/features/permissions/hooks/usePermissions";
import { PermissaoResponse } from "core/features/permissions/typings/types";
import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
  AccordionIcon,
} from "@chakra-ui/react";
import { Tree, Row, Col, Checkbox } from "antd";
import { useState, useEffect, useRef } from "react";
import flatten from "flat";
import _ from "lodash";
export interface InputTablePermissoesProps {
  onChange: (ids: string[]) => void;
  value: string[];
  readonly?: boolean;
  tenantId?: string;
  origem: "app" | "backoffice";
}

export const InputTablePermissoes = ({
  onChange,
  value,
  readonly,
  tenantId,
  origem,
}: InputTablePermissoesProps) => {
  const [checkedKeys, setCheckedKeys] = useState<string[][]>([]);
  const valueRef = useRef(value ?? []);
  useEffect(() => {
    valueRef.current = value;
  }, [value]);

  const { data, isLoading } = usePermissions(
    { origem, tenantId },
    async (d: PermissaoResponse[]) => {
      if (!valueRef.current?.length) {
        return;
      }

      d.forEach((item, index: number) => {
        const flatItems = flatten(item.children);

        const keys = Object.keys((flatItems as any) || {}).filter((item) =>
          item.includes(".key")
        );

        const values = keys.map((key) => {
          return (flatItems as any)[key];
        });

        const result: string[] = [];

        valueRef.current.forEach((v) => {
          if (values.includes(v)) {
            result.push(v);
          }
        });

        // isso é necessario pois no acordion se um pai é marcado, todos os filhos também são marcados
        // e se todos os filhos sao marcados o pai tambem é marcado
        // como esperamos o segundo comportamento (o pai ser marcado quando todos os filhos estiverem marcados)
        // entao remove-se a marcação do pai, ele automaticamente sera marcado caso seus filhos sejam
        const parentIds = Object.entries((flatItems as any) || {}).reduce(
          (agg, [key, value]) => {
            if (key.includes(".parentId")) {
              agg.push(value as string);
            }
            return agg;
          },
          [] as string[]
        );
        checkedKeys[index] = result.filter((item) => !parentIds.includes(item));
      });

      if (Array.isArray(checkedKeys)) {
        setCheckedKeys([...checkedKeys]);
      } else {
        setCheckedKeys([]);
      }
    }
  );
  const onCheck = (checkedKeysValue: string | string[], index: number) => {
    checkedKeys[index] = checkedKeys[index] ?? [];

    if (Array.isArray(checkedKeysValue)) {
      checkedKeys[index] = checkedKeysValue;
    } else {
      checkedKeys[index] = [checkedKeysValue];
    }

    if (Array.isArray(checkedKeys)) {
      setCheckedKeys([...checkedKeys]);
    } else {
      setCheckedKeys([]);
    }

    onChange(
      checkedKeys.reduce((agg, item) => {
        if (Array.isArray(item)) {
          agg.push(...item);
        } else if (typeof item === "string") {
          agg.push(item);
        }
        return agg;
      }, [])
    );
  };

  return (
    <>
      {isLoading ? (
        <Flex alignItems="center" justifyContent="center">
          <Spin size="large" spinning />
        </Flex>
      ) : null}

      {!isLoading ? (
        <Flex flexDir={"column"} gap="16px">
          <Accordion
            defaultIndex={data?.map((_item, index) => index)}
            allowMultiple
            allowToggle
          >
            <Row gutter={32}>
              {data?.map((item, index) => {
                const flatItems = flatten(item.children);

                const keys = Object.keys((flatItems as any) || {}).filter(
                  (item) => item.includes(".key")
                );

                const values = keys.map((key) => {
                  return (flatItems as any)[key];
                });

                const checkAll = item.children.every((child) =>
                  checkedKeys[index]?.includes(child.key)
                );
                const intermediate =
                  checkedKeys[index]?.length !== values.length &&
                  !!checkedKeys[index]?.length;
                if (index === 12) {
                  console.log(item.children);
                  console.log(checkedKeys[index]);
                }
                if (item.children) {
                }
                return (
                  <Col sm={24} key={item.key}>
                    <AccordionItem rounded="8px" bg="white" mb={2}>
                      <AccordionButton _hover={{ bg: "transparent" }}>
                        <Flex fontSize="14px" flex="1" textAlign="left">
                          <Flex>
                            <Checkbox
                              checked={checkAll}
                              disabled={readonly}
                              indeterminate={intermediate}
                              onClick={(ev) => {
                                ev.stopPropagation();
                              }}
                              onChange={(ev) => {
                                if (!ev.target.checked) {
                                  checkedKeys[index] = checkedKeys[
                                    index
                                  ]?.filter((check) => !values.includes(check));

                                  onCheck(checkedKeys[index] ?? [], index);
                                } else {
                                  const nextValue = _.union(
                                    checkedKeys[index],
                                    values
                                  );

                                  onCheck(nextValue, index);
                                }
                              }}
                            />
                          </Flex>
                          <Flex
                            fontWeight="bold"
                            fontSize="16px"
                            flex={1}
                            pl="8px"
                          >
                            {item.title}
                          </Flex>
                          <Flex>
                            {checkedKeys[index]?.length ?? 0}/{values.length}{" "}
                            permissões concedidas
                          </Flex>
                        </Flex>
                        <AccordionIcon />
                      </AccordionButton>

                      <AccordionPanel>
                        <Tree
                          checkable
                          disabled={readonly}
                          onCheck={(v) => {
                            onCheck(v as string[], index);
                          }}
                          checkedKeys={checkedKeys[index] ?? []}
                          treeData={item.children}
                        />
                      </AccordionPanel>
                    </AccordionItem>
                  </Col>
                );
              })}
            </Row>
          </Accordion>
        </Flex>
      ) : null}
    </>
  );
};

export default InputTablePermissoes;
